import React from "react";

// Styles \\
import "../../assets/styles/sections/newsHero.scss";

// Images \\
import newsHero from "../../assets/images/newsHero.svg";

const NewsHero = () => {
  return (
    <section className="newsHero">
      <div className="newsHero_bg">
        <div className="bg"></div>
        <img src={newsHero} alt="news" />
        <div className="container">
          <div className="newsHero_items">
            <div className="newsHero_items_title">
              <p>Home / News</p>
              <h2>Blog Posts</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsHero;
